import { useAppSelector } from "hooks/redux"
import { useDashboardId } from "connected-components/dashboard/context/dashboard-id"
import { DEFAULT_TRADE_STATE } from "connected-components/dashboard/store/trade-slice"

// The current dashboard's trade resetCount, bumped only by resetTrades/resetTradeContext (not
// addTrade) - exactly the ErrorBoundary key signal we want: remount once the user has taken a
// corrective action on trades, not on every trade addition or an unrelated UI interaction.
export function useTradesResetKey(): number {
  const dashboardId = useDashboardId()
  return useAppSelector((state) => state.dashboard.trade[dashboardId]?.resetCount ?? DEFAULT_TRADE_STATE.resetCount)
}
